import { graphql } from "~/gql";

export const LIBRARY_DISBURSEMENTS_QUERY = graphql(/* GraphQL */ `
  query FindLibraryDisbursements($filter: LibraryDisbursementWhereInput!) {
    libraryDisbursements(filter: $filter) {
      ...LibraryDisbursementFragment
    }
  }
`);
